import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export function useApiAuthLogin() {
    return useMutation({
        mutationFn: ({mobile, password}) => ((async (data = {}) => {
            return generalRequest.post(`/auth/login`, data)
        })({mobile, password})),
    });
}


export function useApiAuthCheckMobile() {
    return useMutation({
        mutationFn: ({mobile}) => ((async (data = {}) => {
            return generalRequest.post(`/auth/check`, data)
        })({mobile})),
    });
}

export function useApiAuthOtp() {
    return useMutation({
        mutationFn: ({mobile}) => ((async (data = {}) => {
            return generalRequest.post(`/auth/otp`, data)
        })({mobile})),
    });
}

export function useApiLoginByOtp() {
    return useMutation({
        mutationFn: ({mobile, otp, otp_token}) =>
            ((async (data = {}) => {
                return generalRequest.post(`/auth/login/otp`, data)
            })({
                mobile: mobile,
                otp: otp,
                otp_token: otp_token,

            }))
    })
}


export function useApiLoginWithChildren() {
    return useMutation({
        mutationFn: ({current_user_id, child_user_id}) =>
            ((async (data = {}) => {
                return generalRequest.post(`/auth/login/with-child`, data)
            })({
                current_user_id: current_user_id,
                child_user_id: child_user_id,
            }))
    })
}


export const useGetUserAcademyFamily = (config) => {
    return useQuery({
        queryKey: ['auth', 'getFamily'],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/student/family`)
        })()),
        ...config,
    })
}


export function useApiRecoveryPassword() {
    return useMutation({
        mutationFn: ({mobile, displayname, password, otp, otp_token, password_confirmation}) =>
            ((async (data = {}) => {
                return generalRequest.post(`/auth/recovery`, data)
            })({
                password: password,
                password_confirmation: password_confirmation,
                mobile: mobile,
                otp: otp,
                otp_token: otp_token,
            }))
    })
}


export function useApiAuthRegister() {
    return useMutation({
        mutationFn: ({mobile, displayname, password, otp, otp_token, password_confirmation}) =>
            ((async (data = {}) => {
                return generalRequest.post(`/auth/register`, data)
            })({
                displayname: displayname,
                password: password,
                password_confirmation: password_confirmation,
                mobile: mobile,
                otp: otp,
                otp_token: otp_token,
            }))
    })
}

export function useApiSendOtp() {
    return useMutation({
        mutationFn: ({mobile}) =>
            ((async (data = {}) => {
                return generalRequest.post(`/auth/otp`, data)
            })({
                mobile: mobile,
            }))
    });
}

export function useApiGetOtp() {
    return useMutation({
        mutationFn: ({mobile, otp_token}) =>
            ((async (data = {}) => {
                if (!data?.mobile || !data?.otp_token) {
                    return null
                }

                return generalRequest.get(`/auth/otp?mobile=${data.mobile}&otp_token=${data.otp_token}`)
            })({mobile: mobile, otp_token: otp_token}))
    });

}


export function useApiAuthLogout() {
    return useMutation({
        mutationFn: () =>
            ((async () => {
                return generalRequest.post(`/auth/logout`)
            })())
    });

}


export function useApiAuthAcademies() {
    return useQuery({
        queryKey: ['auth', 'academies'],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/auth/academies`)
        })())
    })
}


export const useGetCurrentUser = (config) => {
    return useQuery({
        queryKey: ['auth', 'currentUser'],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/auth/me`, config)
        })()),
        ...config,
    })
}

